import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Account } from '../model/account';
import { RpcService } from '../../shared/http/rpc.service';

@Injectable()
export class AccountService {
  constructor(private rpc: RpcService) {}

  public getAccount(): Observable<Account> {
    return this.rpc.makeManagerCall('getAccount').pipe(map(Account.fromDto));
  }
}
